import { DateTime } from "luxon";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";


const UtilizationReportListItem = ({
    createdAt,
    format,
    reportFileUrl,
    innerRef,
    filters,
}) => {
    const timeZone = useSelector((state: RootState) => state.user.data.timezone);
    const locale = useSelector((state: RootState) => state.user.data.locale);
    const from = DateTime.fromISO(filters['basePeriodStartDate']).setZone(timeZone).toFormat('MMM d, yyyy');
    const to = DateTime.fromISO(filters['basePeriodEndDate']).setZone(timeZone).toFormat('MMM d, yyyy');
    const comp_from = DateTime.fromISO(filters['comparisonPeriodStartDate']).setZone(timeZone).toFormat('MMM d, yyyy');
    const comp_to = DateTime.fromISO(filters['comparisonPeriodEndDate']).setZone(timeZone).toFormat('MMM d, yyyy');
    const date = DateTime.fromISO(createdAt).setZone(timeZone).setLocale(locale).toFormat('MMM d, yyyy • h:mm a');
    const { t } = useTranslation();

    return (
        <div
            ref={innerRef}
            className={styles.container}
        >
            <span className={styles.fit_content_width}>{t(date)}</span>
            <span className={styles.fit_content_width}>{t(format.toUpperCase())}</span>
            <span className={styles.fit_content_width}>{t(`${from} - ${to}`)}</span>
            <span className={styles.fit_content_width}>{t(`${comp_from} - ${comp_to}`)}</span>
            <a href={reportFileUrl} className={styles.fit_content_width}>
                {t('Download')}
            </a>
        </div>
    );
};

export default UtilizationReportListItem;
